import { Attributes, BaseDashboardConfig } from './base-dashboard-config';
import { FilterExpression } from '../../../services/data.service';
import { Level, PartialPath } from '../../../services/data-tree';

export type DataRequestContext<A extends Attributes> = {
	filter: FilterExpression;
	groupNames: string[];
	subgroupNames: string[];
	measureNames: string[];
	dataRoot?: Level<A, number[]>;
	orderRoot?: Level<unknown, []>;
};

export type DashboardContext<I extends Attributes, A extends Attributes, C extends BaseDashboardConfig<I, A>> = DataRequestContext<A> & {
	config: C;
	tableRootIndex: 0 | 1 | 3;
	aggCombine: (c: Level<A, number[]>[], path: PartialPath<A, number[]>, all: A | undefined, allFiltered: A | undefined) => A | undefined;
};

export function hasDataRoot<R, C extends { dataRoot?: R }>(
	context: C
): context is C & {
	dataRoot: NonNullable<C['dataRoot']>;
} {
	return Boolean(context.dataRoot);
}
